import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-form-control-required-asterix',
  imports: [],
  templateUrl: './form-control-required-asterix.component.html',
  styleUrl: './form-control-required-asterix.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlRequiredAsterixComponent {}
